<template lang="pug">
    div()
        v-card.mt-2( 
            color="transparent"
            max-width="600"
            style="box-shadow:none;"
        )
            v-row.ma-0
                v-col(cols="2")
                    v-avatar
                        img(:src="rev.profileimage" )
                v-col(cols="6")
                    h6.ma-0.font-weight-regular {{rev.name}}  |  
                        span.grey--text {{rev.date}}
                    v-row
                        v-rating(
                            background-color="grey"
                            color="#ffc107"
                            empty-icon="mdi-star-outline"
                            full-icon="mdi-star"
                            half-icon="mdi-star-half-full"
                            half-increments
                            length="5"
                            size="15"
                            :value="parseFloat(rev.rate)"
                            readonly 
                        )
                v-col.text-end(cols="4")
                    v-icon.mx-2 mdi-thumb-up
                    v-icon.mx-2 mdi-comment-alert
            v-row.ma-0
                v-col.pt-0(cols="2")
                v-col.pt-0(cols="10" width="85%")
                    h5.font-weight-regular.text-wrap {{rev.comment}}
                    v-row.ma-0.mt-3
                        v-col.pa-0.pr-2(cols="3" v-for="(img,index) in rev.images" :key="img.key")
                            v-img.mt-2(
                                :src="'https://via.placeholder.com/96x96?text=IMG%20'+rev.name+index"
                            )
        v-divider.mx-5()
</template>
<script>
export default {
    props:['rev']
}
</script>